import { translateKey } from './translate_vue';

export default translateKey;
